import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ux9ddf2zv: FaireProductEntity = {
  token: "p_4ux9ddf2zv",
  type: "product",
  name: 'To-Do List - 5.75" x 8.25" Magnetic Notepad',
  brandName: "Pavilion",
  imageUrl:
    "https://cdn.faire.com/fastly/c5dce039914b2e3dd12da5698a60ad9e9530d0ed8f4efaa48de43678d44b3efd.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2f0ceac175c6d99f37d48a81d1d5827c4b879311e3ca5fcb67b5893b91c0316c.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
